@value mobile from '~styles/breakpoints.module.css';

.errorBanner {
  width: calc(100% - 16px);
  margin: auto;
  background-color: #e84055;
  height: 48px;
  border-radius: 6px;
  box-shadow:
    0px 2px 4px 0px rgba(30, 41, 55, 0.04),
    0px 1px 4px 0px rgba(30, 41, 55, 0.04);
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-top: 8px;
}
.message {
  color: rgb(255, 255, 255);
  font-family: var(--font-family__primary);
  font-size: var(--font-size-14);
  line-height: var(--line-height-14);
  font-weight: 600;
  margin-left: 16px;
}
.alert img {
  width: 16px;
}

.closeButton {
  background: none;
  border: none;
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  padding: 8px;
  margin-left: auto;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.closeButton:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.closeButton:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

@media mobile {
  .errorBanner {
    height: auto;
  }

  .message {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .alert {
    align-self: flex-start;
    margin-top: 15px;
  }
}
